import { BaseModel } from '../../../global/models';

export interface StockCostsSettings extends BaseModel {
  data: StockCostData;
  status: StockCostsProcessStatus;
  expiresAt: Date;
  syncdAt: Date;
}

enum StockCostsProcessStatus {
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export type StockCostData = {
  children: StockCostNode[];
  hasChildren: boolean;
  totalCost: number; // categories total
};

export type StockCostNode = {
  id: string;
  name: string;
  stockCategoryId?: StockCostCategories; // level 0 only
  stock?: number; // null means it has stock issues. (it doesn't have or it's negative). parents add up from children
  unitCost?: number; // only leaf nodes need unit cost (parents don't). parents have null.
  totalCost?: number; // stock * unitCost: null means it should have cost, but it doesn't. parents add up from children
  sku?: string; // only leaf nodes need sku
  children?: StockCostNode[];
  hasChildren: boolean;
  stockIssues: number;
  costIssues: number;
  isVariant: boolean;
  parentId?: string; // useful for variants
  properties?: any[]; // sólo si es variant, necesario para traducir el name
};

enum StockCostCategories {
  COVERS = 'covers',
  LAMINATING_SLEEVES = 'laminating',
  RINGS = 'rings',
  PAPERS = 'papers',
  CUSTOMIZABLE_PAPERS = 'customizablePapers',
  STORE = 'store',
  PACKAGING_MATERIAL = 'packagingMaterial',
}
